"use strict";

exports.__esModule = true;

var _createTheming = _interopRequireDefault(require("./createTheming"));

exports.createTheming = _createTheming.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map